// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filtersLayoutStyles } from "@conklin/App/Widgets/MyLists/MyListsFilterLayout";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { PaginationStyle } from "@insite/mobius/Pagination";
import { css } from "styled-components";

filtersLayoutStyles.container = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 16px;
        justify-content: space-between;
        background-color: ${color("common.ui2")};
        border-radius: 4px;
        padding: 8px;
        align-items: center;
        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }
    `,
};

filtersLayoutStyles.search = {
    css: css`
        ${xScreen("lte", "md")} {
            width: calc(50% - 10px);
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

filtersLayoutStyles.sort = {
    css: css`
        ${xScreen("lte", "md")} {
            width: calc(50% - 10px);
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

filtersLayoutStyles.show = {
    css: css`
        ${xScreen("lte", "md")} {
            width: calc(50% - 10px);
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

filtersLayoutStyles.pagination = {
    css: css`
        display: flex;
        align-items: flex-end;
        margin-left: auto;
        ${PaginationStyle} {
            margin: 0;
            padding: 0;
            flex-wrap: nowrap;
            ${xScreen("lte", "sm")} {
                justify-content: space-between;
            }
            ${FormInputWrapper} {
                width: 51px;
            }
            nav {
                width: auto;
                ul {
                    display: flex;
                    flex-wrap: nowrap;
                }
            }
            span[class^="PerPageSelect"] {
                width: auto;
            }
        }
        ${xScreen("lte", "md")} {
            width: calc(50% - 10px);
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};
